import { Flex } from "antd";
import { styled } from "styled-components";

export const StyledAuthContainer = styled(Flex)`
  height: 100%;
  width: 100%;
  min-width: 0;
  flex: 1;
  justify-content: space-between;
  position: relative;
  z-index: 0;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  background: ${({ theme }) => theme.palette.background.auth};
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.lg}px) {
    padding: 0px 16px 16px 16px;
  }
`;

export const StyledAuthLogoWrapper = styled.div`
  padding: 32px 0 0 45px;
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    padding: 147px 0 0 0;
  }
  @media screen and (max-height: 900px) {
    padding: 32px 0 0 45px;
  }
  @media screen and (max-height: 768px) {
    padding: 32px 0 0 45px;
  }
`;


export const StyledAuthContent = styled(Flex)`
  width: 100%;
  max-width: 572px;
  padding: 0 40px;
  margin: 0 auto;
  align-self: center;
  min-width: 0;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  .ant-flex {
    width: 100%;
  }
  .ant-typography h3 {
    font-weight: 600;
    font-size: 20px;
    color: #101828;
    letter-spacing: -0.4px;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    padding: 0;
  }
  @media screen and (max-height: 900px) {
    gap: 12px !important;
    padding: 0 40px;
  }
  @media screen and (max-height: 768px) {
    gap: 8px !important;
    padding: 0 40px;
  }
`;

export const StyledAuthFooter = styled.div`
  padding: 16px 0 16px;
  text-align: center;
  position: relative;
  z-index: 1;
  @media screen and (max-height: 900px) {
    padding: 10px 0 12px;
  }
  @media screen and (max-height: 768px) {
    padding: 6px 0 8px;
  }
`;
